import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: ErrorPageComponent },
  { path: 'error', component: ErrorPageComponent },
  { path: 'home/:prodotto/:tipoUtenza/:auth', component: HomeComponent },
  { path: 'home/:prodotto/:tipoUtenza/:auth/:id_ctr', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
